import Logger from '../../../services/Logger';
import sdk from '../../../sdk';
import Toast from '../../../components/Toast';
import l18n from '../../../shared/strings';
import { getColorLabels, toStoredColorLabels } from '../../../helpers/colorsHelper';
import applyColorLabelsUpdate from './applyColorLabelsUpdate';

/**
 * The request removes the label from the team configuration and resets it on every asset
 * that carries it. The optimistic update is reverted if it is rejected, which also happens
 * when the label is used by more assets than the server recolors at once.
 */
const deleteColorLabel = (slug) => async (dispatch, getState) => {
  const previousLabels = toStoredColorLabels(
    getColorLabels(getState().user.team?.settings?.colorLabels),
  );
  const nextLabels = previousLabels
    .filter((label) => label.slug !== slug)
    .map((label, order) => ({ ...label, order }));

  // Keep asset colors untouched until the server confirms: CatalogItem already falls back
  // to nocolor for unknown slugs, and clearing here would leave the catalog stuck if the
  // request fails and the label list is rolled back.
  dispatch(applyColorLabelsUpdate(nextLabels, null, { clearStaleAssets: false }));

  try {
    await sdk.team.deleteColorLabel(slug);
    // The initiator is excluded from team.colorLabels.updated, so the local store has to
    // drop the recolored assets itself once the write succeeds.
    dispatch(applyColorLabelsUpdate(nextLabels, getState().user));
    return true;
  } catch (error) {
    dispatch(applyColorLabelsUpdate(previousLabels, null, { clearStaleAssets: false }));
    Logger.error(new Error('Can not delete team color label'), { error }, [
      'DeleteColorLabelFailed',
      { errorMessage: error?.message || 'NoMessage' },
    ]);
    Toast(l18n.TEAMMATES.errorUpdateTeamSetting, { type: 'error' });
    return false;
  }
};

export default deleteColorLabel;
